import React, { memo, useState } from "react"
import { css } from "@emotion/react"
import { CustomerPart } from "@ncs/ncs-api"
import { CardProps } from "@ncs/web-legos"
import { PartCard } from "~/views/shop/part-search-results/components"
import { AddedToCartModalEcomm } from "./AddedToCartModalEcomm"

interface PartCardProps extends CardProps {
	part: CustomerPart
	onAddToCart?: (part: any) => void
}

export const PartPreviewCardEcomm: React.FC<PartCardProps> = memo(
	({ part, onAddToCart, ...rest }) => {
		const [addedPart, setAddedPart] = useState<CustomerPart | null>(null)
		const addToCartHandler = () => {
			setAddedPart(part)
			onAddToCart?.(part)
		}

		return (
			<>
				<PartCard
					part={part as any}
					onAddToCart={addToCartHandler}
					css={partCardStyle}
					{...rest}
				/>
				<AddedToCartModalEcomm
					isOpen={!!addedPart}
					partId={addedPart?.id}
					onClose={() => setAddedPart(null)}
				/>
			</>
		)
	}
)

const partCardStyle = css`
	height: 100%;
`
